import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { LogApi } from '@Apis';
import { VaReportParams } from 'src/types/log';

const DownloadSummaryReportModal = (props: {
  visible: boolean;
  onClose: () => void;
  summaryReportParams: VaReportParams;
}) => {
  const { visible, onClose, summaryReportParams } = props;
  const { t } = useTranslation();
  const downloadSummaryReport = (data: any) => {
    const url = window.URL.createObjectURL(
      new Blob([data], { type: 'text/html;charset=utf-8;' })
    );
    const link = document.createElement('a');
    link.href = url;
    link.download = 'ddaaas_report.html';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const onApply = async () => {
    onClose();
    try {
      const data = await LogApi.getSummaryReport(summaryReportParams);
      downloadSummaryReport(data);
    } catch (error) {
      window.showNotification({
        titleMsg: t('errors.log.downloadSummaryReport.title'),
        bodyMsg: t('errors.log.downloadSummaryReport.body'),
        severity: 'error',
      });
    }
  };

  return (
    <Modal isOpen={visible} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalBody>{t('log.modals.ddaaasReport.desc')}</ModalBody>
        <ModalFooter>
          <Button width="43x" variant="primary" onClick={onApply}>
            {t('common.button.ok')}
          </Button>
          <Space width="2x" />
          <Button width="65x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DownloadSummaryReportModal;
